import { Map } from "immutable";
import _ from "lodash";

const getPositionsFromTree = (subtree, position, result) => {
  subtree.children.map((c, i) => {
    let p = _.clone(position);
    p.push(i + 1);
    if (c.id) {
      result[c.id] = p;
    }
    getPositionsFromTree(c, p, result);
  });
};

export default tree => {
  let result = {};
  getPositionsFromTree(tree, [], result);
  return Map(result);
};
